import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getToken } from '../../services/tokenService';
import { API } from './constants';

// ?relance=<devis_id> : pré-remplit le simulateur (membre, CA, activités) d'une proposition restée sans montant.
export function useRelancePrefill({
  location, autoCalcDoneRef, setFormData, setModeCalcul, setMembreData,
  setSelectedActivitesGO, setSelectedActivites2nd, setSelectedActivitesTP, setSelectedActivitesPIB,
}) {
  useEffect(() => {
    const devisId = new URLSearchParams(location.search).get('relance');
    if (!devisId) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/batico/proposition/by-devis/${encodeURIComponent(devisId)}/prefill`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        if (cancelled) return;
        if (autoCalcDoneRef) autoCalcDoneRef.current = false;
        if (data.ca_ht) setFormData((prev) => ({ ...prev, ca_ht: String(Math.round(Number(data.ca_ht))) }));
        if (data.nombre_jours) setFormData((prev) => ({ ...prev, nombre_jours: String(data.nombre_jours) }));
        if (data.type_souscription === 'nominative') setModeCalcul('nominative');
        if (data.membre_prefill && Object.keys(data.membre_prefill).length) setMembreData((prev) => ({ ...(prev || {}), ...data.membre_prefill }));
        const sel = data.activites_selectionnees || {};
        const det = data.activites_details || {};
        const ids = (k) => (Array.isArray(sel[k]) && sel[k].length ? sel[k] : (det[k] || []).map((a) => a?.id).filter(Boolean));
        const nb = [['gros_oeuvre', setSelectedActivitesGO], ['second_oeuvre', setSelectedActivites2nd], ['travaux_publics', setSelectedActivitesTP], ['pib', setSelectedActivitesPIB]]
          .reduce((n, [k, set]) => { const v = ids(k); if (v.length) set(v); return n + v.length; }, 0);
        toast.info('Simulateur pré-rempli', {
          description: `${data.ca_ht ? 'CA' : 'CA à saisir'}${nb ? ` et ${nb} activité(s)` : ', activités à sélectionner'} repris de la proposition. Vérifiez puis lancez le calcul.`,
          duration: 7000,
        });
      } catch (e) {
        if (!cancelled) toast.warning('Proposition introuvable', { description: 'Saisissez le CA et les activités pour lancer une nouvelle simulation.' });
      }
    })();
    return () => { cancelled = true; };
  }, [location.search]); // eslint-disable-line react-hooks/exhaustive-deps
}
